export default {
      id: "icon-menu-survey_questionary-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#icon-menu-survey_questionary-usage",
      toString: function () {
        return this.url;
      }
    }